export default {
  header: {
    hours: "Senin-Jumat : 07.00 - 17.00",
  },
  nav: {
    home: "Home",
    profile: "Profile",
    products: "Produk",
    concrete: "Industri Beton",
    mine: "Industri Tambang",
    media: "Media",
    gallery: "Gambar",
    article: "Artikel",
    news: "Berita",
    faq: "FAQ",
    contact: "Hubungi Kami",
  },
  common: {
    article: "Artikel",
    news: "Berita",
    readMore: "Baca Selengkapnya",
    statsYears: "Years Experience",
    statsEmployees: "Employee Expert",
    statsProjects: "Projek Realize",
  },
  cta: {
    title: "Terus bergerak dan memberi solusi untuk industri Indonesia",
    subtitle: "Ceritakan kebutuhan Anda, tim kami siap membantu.",
  },
  footer: {
    contactInfo: "Informasi Kontak",
    address:
      "Kawasan Industri Mekar Jaya KM.7 Jl. Karet IV No. 36 - 40, Mekar Jaya, Sepatan, Kab. Tangerang, Banten 15520",
    company: "Perusahaan",
    profile: "Profil",
    concreteProducts: "Produk Industri Beton",
    mineProducts: "Produk Industri Tambang",
    gallery: "Galeri",
    help: "Bantuan",
    article: "Artikel",
    news: "Berita",
    follow: "Ikuti Kami",
    privacy: "Privacy Policy",
    terms: "Terms & Condition",
  },
  home: {
    badgeLabel: "Selamat Datang di",
    heroTitle: "Solusi Cerdas Untuk Kebutuhan Dalam Industri",
    heroSubtitle:
      "Kami bekerja untuk meningkatkan produktivitas, efektivitas & kemudahan dengan solusi terbaik yang inovatif.",
    aboutTag: "Sekilas Tentang Ligno Specialty Chemicals",
    aboutTitle: "Mitra solusi kimia industri Indonesia sejak 2001",
    aboutBody:
      "<b>PT. Ligno Specialty Chemicals (LSC)</b> adalah perusahaan produsen kimia industri di Tangerang, Banten, berdiri sejak tahun 2001, sebelumnya selama lebih dari lima tahun aktif sebagai perusahaan agen dan distributor untuk produk Lignosulfonat di Indonesia",
    knowUs: "Kenal Lebih Dekat",
    whyTitle: "Kenapa Ligno Specialty Chemicals?",
    whySubtitle:
      "Komitmen yang kami pegang dalam melayani kebutuhan industri Anda.",
    reasons: {
      r1: {
        title: "Kompeten",
        text: "LIGNO didukung oleh sumber daya yang kompeten dan passionate di bidangnya",
      },
      r2: {
        title: "Kualitas Produk Terjamin",
        text: "LIGNO memastikan kualitas material product terjaga karena sudah memiliki standar international ISO 9001",
      },
      r3: {
        title: "Cepat",
        text: "LIGNO menawarkan kecepatan dengan struktur perusahaan yang ramping dan efisien.",
      },
      r4: {
        title: "Amanah",
        text: "LIGNO telah dipercaya di berbagai industri lebih dari 10 tahun",
      },
    },
    solutionTitle1: "Memberikan Solusi",
    solutionTitle2: "Disetiap Kebutuhan",
    solutionBody:
      "Lebih dari sekadar penyedia produk, Ligno adalah mitra solusi yang membantu pelanggan menghadapi setiap tantangan melalui layanan yang andal, produk berkualitas, dan pendekatan yang berorientasi pada hasil.",
    seeActivities: "Lihat Kegiatan Kami",
    locationTitle: "Lokasi Kami",
    locationHours: "Senin - Jumat, 07.00 - 17.00",
    openMap: "Buka Peta",
    testimonyTitle: "Kata Mereka Tentang Ligno Specialty Chemicals",
    testimonySubtitle: "Pengalaman mereka bekerja sama dengan LIGNO.",
    articlesTitle: "Terus Bergerak dan Memberi Solusi",
  },
  profile: {
    introTitle1: "Kami hadir dengan",
    introTitleEm: "memberikan solusi dan produk yang terbaik",
    introTitle2: "untuk memenuhi kebutuhan Industri di Indonesia",
    aboutP1:
      "<b>PT. Ligno Specialty Chemicals (LSC)</b> adalah perusahaan produsen kimia industri di Tangerang, Banten, berdiri sejak tahun 2001, sebelumnya selama lebih dari lima tahun aktif sebagai perusahaan agen dan distributor untuk produk Lignosulfonat di Indonesia",
    aboutP2:
      "PT. Ligno Specialty Chemicals sejak awal berdiri hingga saat ini terus aktif dalam mengembangkan produk-produk unggulan sehingga dapat bersaing dari segi kualitas dengan harga yang kompetitif. Kami Menjunjung profesionalisme dan selalu berusaha untuk memberikan solusi inovatif dan bekerja dalam semangat kebersamaan, kami selalu memberikan penghormatan kepada lingkungan.",
    valuesTitle: "Ligno Specialty Chemicals Menjunjung Tinggi Nilai-Nilai Inti",
    values: {
      v1: {
        title: "Kompeten",
        text: "LIGNO didukung oleh sumber daya yang kompeten dan passionate di bidangnya",
      },
      v2: {
        title: "Kualitas Produk Terjamin",
        text: "LIGNO memastikan kualitas material product terjaga karena sudah memiliki standar international ISO 9001",
      },
      v3: {
        title: "Cepat",
        text: "LIGNO menawarkan kecepatan dengan struktur perusahaan yang ramping dan efisien.",
      },
      v4: {
        title: "Amanah",
        text: "LIGNO telah dipercaya di berbagai industri lebih dari 20 tahun",
      },
    },
    historyTitle: "Sekilas Sejarah PT Ligno Specialty Chemicals",
    historyAria: "Periode sejarah",
    period: "Periode",
    history: {
      h0: {
        t1: "Awal",
        d1: "LSC sebagai representative produsen terbesar lignosulfonate dunia",
        t2: "Legal",
        d2: "Badan hukum LSC dibentuk dan menjadi distributor 2 produsen raksasa lignosulfonate dunia",
      },
      h1: {
        t1: "Produksi Pertama",
        d1: "LSC memulai proses produksi dan development mandiri dibawah merk LIGNO dengan customer pertamanya produsen karbon black terbesar di Indonesia",
        t2: "Pabrik Pertama",
        d2: "Membangun pabrik pertama di Tangerang",
      },
      h2: {
        t1: "Concrete Laboratory",
        d1: "Ekspansi pabrik dan pendirian laboratorium beton",
        t2: "Chemical Laboratory",
        d2: "Ekspansi pabrik dan pembangunan laboratorium baru serta ekspansi ke industri fertilizer",
      },
      h3: {
        t1: "Representatives",
        d1: "Menempatkan sales representative di Surabaya dan Padang",
        t2: "Kerjasama",
        d2: "Dipercaya oleh berbagai BUMN dari segala bidang dan menjalin kerjasama riset dengan universitas",
      },
      h4: {
        t1: "Modern Laboratory",
        d1: "Perluasan pabrik dan pembangunan lab kimia modern",
        t2: "Kerjasama Riset",
        d2: "Menjalin kerjasama riset dengan BUMN",
      },
    },
    visiTitle: "Visi PT Ligno Specialty Chemicals",
    visiText:
      "Menjadi perusahaan kimia manufaktur terbaik yang mampu bersaing secara global",
    misiTitle: "Misi PT Ligno Specialty Chemicals",
    misiText:
      "Menghasilkan produk kimia unggulan yang ramah lingkungan serta mengutamakan kepuasaan pelanggan.",
  },
  faq: {
    titleEm: "Frequently",
    titleRest: " Asked Question",
    subtitle:
      "Temukan jawaban atas pertanyaan yang sering diajukan seputar Ligno Specialty Chemicals",
  },
  article: {
    titleEm: "Artikel",
    titleRest: " Ligno",
    subtitle:
      "Lengkapi perkembangan dunia Industri dengan tips, kisah sukses, dan pembaruan produk terkini dari Ligno Specilaty Chemicals.",
    searchPlaceholder: "Pencarian Artikel",
  },
  news: {
    titleEm: "Berita",
    titleRest: " Ligno",
    subtitle:
      "Ikuti perkembangan kegiatan yang dilakukan Ligno Specialty Chemicals",
    searchPlaceholder: "Pencarian Berita",
  },
  gallery: {
    titleEm: "Galeri",
    titleRest: " Ligno",
    subtitle:
      "Dokumentasi kegiatan dan fasilitas dari Ligno Specialty Chemicals",
  },
  detail: {
    backToArticles: "Kembali Ke Semua Artikel",
    backToNews: "Kembali Ke Semua Berita",
    readOtherArticles: "Baca Artikel Lainnya",
    readOtherNews: "Baca Berita Lainnya",
    readOthersDefault: "Baca Artikel & Berita Lainnya",
  },
};
